import {ValueObject} from '@s-ui/domain'

export class CreateLastCallRequestValueObject extends ValueObject {
  /**
   * @param {String}  adId
   * @param {String}  dealerId
   * @param {String}  makeId
   * @param {String}  title
   * @param {String}  uniqueVehicleId
   * @param {String}  postalCode
   * @param {String}  userId
   * */

  toJSON() {
    return {
      originalAd: {
        adId: this._adId,
        dealerOwner: this._dealerId,
        makeId: this._makeId,
        title: this._title,
        uniqueVehicleId: this._uniqueVehicleId
      },
      postalCode: this._postalCode,
      userId: this._userId
    }
  }
}
